<template>
  <span class="mail-status-empty">
    <span aria-hidden="true">-</span>
    <span class="visually-hidden">{{ $t("mail_status.not_filled") }}</span>
  </span>
</template>

<script>
export default {
  name: "MailStatusEmptyComponent",
};
</script>

<style lang="scss" scoped>
.mail-status-empty {
  color: $m-color_7;

  @include dark-theme {
    color: $m-color_4;
  }
}
</style>
